import * as yup from 'yup';
import { messages } from 'app/config/constants';

export const caseAttachmentSchema = yup.object().shape({
  requestAttachment: yup.array().min(1, messages.MANDATORY_FIELD),
  createdDate: yup.date().required(messages.MANDATORY_FIELD),
  fileWrapper: yup.mixed().notRequired(),
  multipartFile: yup.mixed().notRequired(),
  name: yup.string().when(['fileWrapper', 'multipartFile'], (keys, schema) => {
    if (!keys[0] && !keys[1]) {
      return schema.notRequired();
    }
    return schema.required(messages.MANDATORY_FIELD);
  }),
});
